import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const WellStageValidator = t.intersection([
  t.type({
    id: t.string,
    stage: t.string,
    regionId: t.string,
  }),
  t.partial({
    externalId: t.string,
    invoiceCategory: t.string,
    invoiceGrouping: t.boolean,
    maxDuration: t.number,
    createdById: t.string,
    lastModifiedById: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const WellStageArrayValidator = t.array(WellStageValidator);

export type WellStage = t.TypeOf<typeof WellStageValidator>;
export type WellStageArray = t.TypeOf<typeof WellStageArrayValidator>;

@Exclude()
export class WellStageEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  stage!: string;

  @Expose()
  regionId!: string;

  @Expose()
  externalId?: string;

  @Expose()
  invoiceCategory?: string;

  @Expose()
  invoiceGrouping?: boolean;

  @Expose()
  maxDuration?: number;

  @Expose()
  createdById?: string;

  @Expose()
  lastModifiedById?: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'WELLSTAGE';

  get displayName(): Readonly<string> {
    return this.stage;
  }

  /**
   * Constructor for WellStageEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: WellStage): WellStageEntity {
    return plainToInstance(WellStageEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<WellStage> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(WellStageValidator, object);
  }

  asTypeValue(): WellStage {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(WellStageValidator, object);
  }
}
